export default class PageManagement {
  constructor(options) {
    document
      .getElementById("reorganize-pages")
      ?.addEventListener("click", (e) => this.reorganizePages(e));

  }

  reorganizePages(event) {
    event.preventDefault();
    $('.reorganize-pages-button-cancel').on('click', this.reorganizePagesCancel);
    $('.reorganize-pages-button-save').on('click', this.reorganizePagesSave);

    $('.admin-input').hide();
    $('#page-management-sidebar').hide();
    $('.reorganize-pages-button-save').show();
    $('.reorganize-pages-button-cancel').show();

    $('.sidebar-child').addClass('no-nesting');

    $('.admin-sidebar-pages').nestedSortable({
      opacity: 0.4,
      revert: 250,
      tabSize: 25,
      helper: 'clone',
      forcePlaceholderSize: true,
      placeholder: 'placeholder',
      disableNestingClass: 'no-nesting',
      handle: 'div',
      items: 'li',
      tolerance: 'pointer',
      toleranceElement: '> div',
      maxLevels: 2,
      isTree: true,
      startCollapsed: false,
      expandOnHover: 700,
      listType: 'ul',
      relocate: function() {
        $('.no-nesting').removeClass('no-nesting');
        $('.mjs-nestedSortable-branch .mjs-nestedSortable-leaf').addClass('no-nesting');
      }
    });
  }

  reorganizePagesSave(event) {
    event.preventDefault();

    var newOrder = $('.admin-sidebar-pages').nestedSortable('toArray', {startDepthCount: 0});

    var pageId = $('input[name$="page_id"]').val();
    $('.reorganize-pages-button-save').text('Working...');

    $.ajax({
      type: "POST",
      url: "/admin/pages/" + pageId + "/reorganize",
      data: {
        'page_list' : JSON.stringify(newOrder)
      },
      dataType: 'html',
      success: function(data, status) {
        window.location.reload();
      }
    });

  }

  reorganizePagesCancel(event) {
    event.preventDefault();
    window.location.reload();
  }
}
